import { Route, Routes } from "react-router-dom";
import HomePage from "../pages/Home";
import CreateEmployeePage from "../pages/Employees/create";
import ViewEmployeePage from "../pages/Employees/View";
import DocumentsPage from "../pages/Documents";
import CreateDocumentPage from "../pages/Documents/create";
import ViewDocumentPage from "../pages/Documents/view";
import AttendancePage from "../pages/Attendance";
import PayrollPage from "../pages/Payroll";
import CreatePayrollRunPage from "../pages/Payroll/create";
import ViewPayrollRunPage from "../pages/Payroll/view";
import EmployeesPage from "../pages/Employees";
import SettingsPage from "../pages/Settings";
import LeaveRequestsPage from "../pages/LeaveRequests";
import CreateAttendancePage from "../pages/Attendance/create";
import BulkCreatePage from "../pages/Attendance/bulk_create";
import CreateLeaveRequestPage from "../pages/LeaveRequests/create";
import { PermissionRoute } from "../../../routes/PermissionRoute";

export default function HRRoutes() {
  return(
    <Routes>
      <Route element={<PermissionRoute permission="hr.home" />}>
        <Route path="home" element={<HomePage />} />
      </Route>

      <Route path="employees" element={<PermissionRoute permission="hr.employees.view" />}>
        <Route path="" element={<EmployeesPage />} />
        <Route path="create" element={<CreateEmployeePage />} />
        <Route path="edit/:id" element={<CreateEmployeePage />} />
        <Route path="view/:id" element={<ViewEmployeePage />} />
      </Route>

      <Route path="documents" element={<PermissionRoute permission="hr.documents.view" />}>
        <Route path="" element={<DocumentsPage />} />
        <Route path="create" element={<CreateDocumentPage />} />
        <Route path="view/:id" element={<ViewDocumentPage />} />
      </Route>

      <Route path="attendance" element={<PermissionRoute permission="hr.attendance.view" />}>
        <Route path="" element={<AttendancePage />} />
        <Route path="create" element={<CreateAttendancePage />} />
        <Route path="bulk-create" element={<BulkCreatePage />} />
      </Route>

      <Route path="payroll" element={<PermissionRoute permission="hr.payroll.view" />}>
        <Route path="" element={<PayrollPage />} />
        <Route path="create" element={<CreatePayrollRunPage />} />
        <Route path="view/:id" element={<ViewPayrollRunPage />} />
      </Route>

      <Route path="leave-requests" element={<PermissionRoute permission="hr.leave_requests.view" />}>
        <Route path="" element={<LeaveRequestsPage />} />
        <Route path="create" element={<CreateLeaveRequestPage />} />
      </Route>

      <Route path="settings" element={<PermissionRoute permission="hr.settings.manage" />}>
        <Route path="" element={<SettingsPage />} />
      </Route>
    </Routes>
  );
}